import './style.scss';

import { Spin } from 'antd';
import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';

const LoadingComponent = () => {
  return (
    <div className="loading-component">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 128 }} spin />} />
    </div>
  );
};

export default LoadingComponent;
